import { $post } from "~p/util/request"
import { CookieSet,CookieGet,CookieRemove } from "@/utils/cookie"
import router from '@/router'; 

const state = {
  user_id:"",
  user_info:"",
  user_token:""
}

const mutations = {
  SET_USER_ID: (state, id) => {
    state.user_id = id
  },
  SET_USER_INFO: (state, info) => {
    state.user_info = info
  },
  SET_USER_TOKEN: (state, token) => {
    state.user_token = token
  }
}
const actions = {
  async login({ commit },loginFrom) {
    return new Promise(async (reject,resolve)=>{
      try {
        let res = await $post("Login",{
          "UserName": loginFrom.inp1,
          "Pwd": loginFrom.inp2
        })
        console.log(res,'res');
        let userId = res.data.ResultData[0].id
        let token = res.data.ResultData[0].token
        console.log(res.data,'userid');
        commit("SET_USER_ID",userId);
        CookieSet("user_id",userId);
        commit("SET_USER_TOKEN",token);
        CookieSet("user_token",token);
        console.log(commit("SET_USER_TOKEN",token),'token1');
        console.log(CookieGet("user_token"),'token2');
        reject()
      } catch (error) {
        resolve()
      }
    })
  },
  async getInfo({ commit,state }){
    return new Promise(async reject=>{
      if(state.user_id === "" && CookieGet("user_id")){
        commit("SET_USER_ID",CookieGet("user_id"))
        commit("SET_USER_TOKEN",CookieGet("user_token"))
      }
      let { data:{ResultData} } = await $post("GetUserModel")
      commit("SET_USER_INFO", ResultData)
      reject(ResultData)
    })
  },
  logout({ commit }) {
    CookieRemove('user_id')
    commit("SET_USER_ID", "")
    commit("SET_USER_TOKEN", "")
    commit("SET_USER_INFO", "")
    router.push("/")
  },
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
